import { Bar } from "react-chartjs-2";

import Chart from "chart.js";

const AgeChart = ({ ageList }) => {
	const data = {
		type: "horizontalBar",
		labels: ageList.map((item) => item.distribution_key),
		datasets: [
			{
				label: "연령대",
				data: ageList.map((item) => item.userCount),
				backgroundColor: "rgba(54, 162, 235, 0.2)",
				borderColor: "rgba(54, 162, 235, 1)",
				borderWidth: 1,
			},
		],
	};

	const options = {
		// type: 'horizontalBar',
		indexAxis: "y",
		responsive: true,
		maintainAspectRatio: false,
		plugins: {
			legend: {
				position: "top",
			},
			title: {
				display: true,
				text: "연령대",
			},
		},
		scales: {
			y: {
				beginAtZero: true,
			},
		},
	};
	return (
		<div style={{ position: "relative", width: "100%", height: "30vh" }}>
			<Bar type="horizontalBar" data={data} options={options} />
		</div>
	);
};

export default AgeChart;
